import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function useFolders(userId) {
  const [folders, setFolders] = useState([]);

  const fetchFolders = async () => {
    if (!userId) return;
    const { data } = await supabase
      .from("qr_folders")
      .select("*")
      .eq("user_id", userId)
      .order("created_at");
    setFolders(data || []);
  };

  const createFolder = async (name, color = "#ef4444") => {
    const { data, error } = await supabase
      .from("qr_folders")
      .insert([{ user_id: userId, name, color }])
      .select()
      .single();
    if (!error) setFolders(prev => [...prev, data]);
    return data;
  };

  const deleteFolder = async (id) => {
    await supabase.from("qr_folders").delete().eq("id", id);
    setFolders(prev => prev.filter(f => f.id !== id));
  };

  useEffect(() => { fetchFolders(); }, [userId]);

  return { folders, fetchFolders, createFolder, deleteFolder };
}